/* eslint-disable no-console */
import dbInstance from "../instance";
import { IPendingMutation } from "../schemas";

function buildId(documentId: string, objectNamespace: string, objectId: string) {
    return `${documentId}_${objectNamespace}_${objectId}`;
}

// TODO: Does mutation have fixed structure? If yes, this should be refined
interface ISavePendingMutationOptions {
    objectNamespace: string;
    objectId: string;
    documentId: string;
    revisionId: number;
    mutations: any[];
}
export function savePendingMutation(options: ISavePendingMutationOptions): Promise<IPendingMutation | null> {
    const { documentId, objectNamespace, objectId, mutations, revisionId } = options;
    const id = buildId(documentId, objectNamespace, objectId);

    return new Promise((resolve, reject) => {
        dbInstance
            .transaction("rw?", dbInstance.table("pendingMutations"), () => {
                const dataToStore: IPendingMutation = {
                    id,
                    documentId,
                    objectId,
                    objectNamespace,
                    revisionId,
                    mutations,
                };

                if (mutations.length === 0) {
                    return dbInstance
                        .table("pendingMutations")
                        .delete(id)
                        .then(() => {
                            resolve(null);
                        });
                }

                return dbInstance
                    .table("pendingMutations")
                    .update(id, dataToStore)
                    .then((updated) => {
                        // If not updated, that means no record previous created. Create one.
                        if (!updated) {
                            return dbInstance
                                .table("pendingMutations")
                                .add(dataToStore)
                                .then(() => {
                                    resolve(dataToStore);
                                });
                        }

                        resolve(dataToStore);
                    });
            })
            .catch((err) => {
                console.error(err);
                reject(err.stack);
            });
    });
}

interface IDeletePendingMutationOptions {
    documentId: string;
    objectNamespace: string;
    objectId: string;
}
export function deletePendingMutation(options: IDeletePendingMutationOptions): Promise<void> {
    const { documentId, objectNamespace, objectId } = options;
    const id = buildId(documentId, objectNamespace, objectId);

    return new Promise((resolve, reject) => {
        dbInstance
            .transaction("rw?", dbInstance.table("pendingMutations"), () => {
                return dbInstance.table("pendingMutations").delete(id);
            })
            .then(() => {
                resolve();
            })
            .catch((err) => {
                console.error(err);
                reject(err.stack);
            });
    });
}

interface IGetPendingMutationOptions {
    documentId: string;
    objectNamespace: string;
    objectId: string;
}
// TODO: Refine return type
export function getPendingMutation(options: IGetPendingMutationOptions): Promise<IPendingMutation | null> {
    const { documentId, objectNamespace, objectId } = options;
    const id = buildId(documentId, objectNamespace, objectId);

    return new Promise((resolve, reject) => {
        dbInstance
            .transaction("r?", dbInstance.table("pendingMutations"), () => {
                return dbInstance
                    .table("pendingMutations")
                    .get(id)
                    .then((pendingMutation) => {
                        return pendingMutation || null;
                    });
            })
            .then((pendingMutation) => {
                resolve(pendingMutation);
            })
            .catch((err) => {
                console.error(err);
                reject(err.stack);
            });
    });
}
